export enum LoaderSize {
  mini = 'mini',
  small = 'small',
  medium = 'medium',
  large = 'large',
  extra = 'extra',
}
